<section class="playground">
  <h2 class="playground__heading">Card</h2>
  <p class="playground__hint">
    <code>common-card</code> base + familias <code>common-frequent-access-card</code> y
    <code>common-schedule-card</code> (UI Kit Figma <code>6512:33797</code>).
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>title</span>
        <input type="text" [(ngModel)]="title" />
      </label>
      <label class="playground__field">
        <span>subtitle</span>
        <input type="text" [(ngModel)]="subtitle" />
      </label>
      <label class="playground__field">
        <span>body</span>
        <textarea rows="4" [(ngModel)]="body"></textarea>
      </label>
    </div>

    <div class="playground__preview-box">
      <div class="playground__cards">
        <common-card [title]="title" [subtitle]="subtitle">
          {{ body }}
        </common-card>

        <common-frequent-access-card [data]="frequentAccessCard"></common-frequent-access-card>

        <common-schedule-card [data]="scheduleCard"></common-schedule-card>
      </div>
    </div>
  </div>
</section>
